export default __webpack_public_path__ + "static/media/newLogo.807b98ef.jpeg";